<template>
  <div class="select-standard-box"ref="selectBox">
    <!--遮罩层-->
    <div class="background-mask" ref="backMask" @click="closeStandard" v-show="ifshow"></div>
    <div class="select-standard-body" :class="{ 'selected-active': ifshow }">
      <div class="standard-heaader">
        <div class="close-btn" @click="closeStandard">
          <van-icon name="cross" color="#ccc" size="18px" />
        </div>
        <div class="goods-header">
          <!--规格图片-->
          <div class="standard-img">
            <img v-bind:src="selectedStandard.picUrl" alt="" />
          </div>
          <!--价格，已选规格-->
          <div class="price-box">
            <goodsPrice :price="selectedStandard.price" :mainSize="16"></goodsPrice>
            <div>
              <span class="has-select">已选</span>
              <span class="selected-standard-name">{{ selectedStandardName }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="standard-content">
        <!--规格列表-->
        <div class="all-standard-list">
          <div v-for="(item, index) in allStandardList" class="standard-item-box">
            <div class="standard-name">{{ item.name }}</div>
            <self-button
              type="primary"
              min-width="40"
              v-for="(item2, index2) in item.valueArr"
              :class="{ 'selected-item': item.selectIndex === item2.index }"
              @on-click="selectStandard(index, item2.index)"
            >
              {{ item2.name }}
            </self-button>
          </div>
        </div>
        <!--选择数量-->
        <div class="select-num clearfix">
          <span class="select-num-name">数量</span>
          <inputNumber
            ref="inputNum"
            :number.sync="selectedNum"
            :product-id="selectedStandard.id"
            @getNumber="getNumber"
          ></inputNumber>
        </div>
      </div>
      <!--加入购物车，购买商品按钮-->
      <div class="bottom-btn-box">
        <div class="add-shopping-cart" :class="{'no-stock':selectedNum == 0}" v-show="btnType === 0" @click="addToCart">加入购物车</div>
        <div class="buy-btn" :class="{'no-stock':selectedNum == 0}" v-show="btnType === 0" @click="buyNow">立即购买</div>
        <div class="confirm-btn" :class="{'no-stock':selectedNum == 0}" v-show="btnType === 1 || btnType === 2" @click="confirm">确定</div>
      </div>
      <van-loading class="standard-loading" color="#45C5DA" v-show="showLoading" />
    </div>
  </div>
</template>

<script>
import inputNumber from 'components/input-number';
import api from 'api/user';
import { Toast } from 'vant';
import { getToken, gotoOAuth } from 'common/js/ovoSystem';
export default {
  components: {
    inputNumber,
  },
  props: {
    ifshow: {
      type: Boolean,
      default: false,
    },
    goodsDetail: {
      type: Object,
      default() {
        return {};
      },
    },
    btnType: {
      //选择规格时下方按钮的类型 0：加入购物车/购买 1：确定（加入购物车） 2：确定（立即购买）
      type: Number,
      default: 0,
    },
    defaultStandard: {
      type: Object
    },
    iffromCart: { //是否是在购物车调用的组件，用于选择规格后是否展示提示
      type: Boolean,
      default: false
    },
    distributionUser: { //分销员信息,需传到结算页
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      selectedStandard: {},
      selectedNum: 1, //选择商品个数
      allStandardList: [],
      cartList: [], //购物车列表
      showLoading: false
    };
  },
  computed: {
    //已选规格名称
    selectedStandardName() {
      const name = this.selectedStandard.specificationsNames;
      return `${name?name+',':''}${this.selectedNum}个`;
    },
    ifbingphone() { //是否绑定手机号，有涉及用户信息的操作时如果没有绑定则需要去绑定
      return this.$store.state.ifBindPhone
    }
  },
  watch: {
    goodsDetail: {
      handler(nval, oval) {
        //商品无规格
        if (!this.goodsDetail.goodsProductList[0]) {
          return
        }
        this.getStandardList();
        this.showLoading = false;
      },
      deep: true,
    },
    ifshow(nval){
      if (nval) {
        this.$refs.selectBox.style.zIndex = 99;
        //如果是购物车里编辑规格，则需要加loading
        if (this.defaultStandard) {
          this.showLoading = true;
        }
      }else{
        this.$refs.selectBox.style.zIndex = -1;
      }
    }
  },
  mounted() {
    this.$refs.selectBox.style.height = this.$refs.backMask.style.height = window.innerHeight + 'px';
  },
  methods: {
    //初始化规格列表
    getStandardList() {
      //第一个规格作为默认规格
      if (!this.defaultStandard) {
        this.selectedStandard = this.goodsDetail.goodsProductList[0];
      } else{
        this.goodsDetail.goodsProductList.map(item=>{
          if (item.id === this.defaultStandard.productId) {
            this.selectedStandard = item;
          }
        })
      }
      //如果库存为0
      if (this.selectedStandard.num === 0) {
        this.selectedNum = 0;
      }
      //获取本商品的所有规格
      this.allStandardList = this.goodsDetail.goodsSpecificationsList;
      //从默认规格列表中筛选出本商品的规格  默认规格values为'黑，白，红'，如果本商品使用的规格下标selectedIndex为'0,2'，那么本商品使用的规格为'黑，红',同时下面
      //valurarr里的index就是对应的0 和 2
      this.allStandardList.map((item,index) => {
        let arr = item.values.split(',');
        let Indexarr = item.selectedIndex.split(',');
        item.valueArr = Indexarr.map((val) => {
          return {
            name: arr[val],
            index: val, //这个下标是当前规格对应的默认规格列表的下标
          };
        });
        if (!this.defaultStandard) {
          item.selectIndex = item.valueArr[0].index; //已选规格默认第一个
        }else{
          let indexArr = this.selectedStandard.specificationsIndexes.split(',');
          item.selectIndex = indexArr[index];
        }
      });
    },
    //选择规格
    selectStandard(index, index2) {
      let item = this.allStandardList[index];
      item.selectIndex = index2;
      //将已选的规格下标排列，筛选出对应的规格商品
      const arr = this.allStandardList.reduce((cur, item) => cur.concat(item.selectIndex), []);
      const indexStr = arr.join(',');
      this.goodsDetail.goodsProductList.map((item, index) => {
        if (item.specificationsIndexes === indexStr) {
          this.selectedStandard = item;
        }
      });
      this.$forceUpdate();
      //切换规格需要把商品数量设置为1
      this.$refs['inputNum'].setInitNum(this.selectedStandard.id)
    },
    //修改商品数量
    getNumber(num) {
      this.selectedNum = num;
      this.$emit('select-standard',{
        ...this.selectedStandard,
        selectedNum: num
      })
    },
    //加入购物车
    async addToCart() {
      //未登录注册
      if (!getToken()) {
        //没有登陆过就跳转鉴权页
        let ua = navigator.userAgent.toLowerCase();//获取判断用的对象
        if (ua.match(/MicroMessenger/i) === "micromessenger" || (Array.isArray(ua.match(/MicroMessenger/i)) && ua.match(/MicroMessenger/i)[0] === "micromessenger")) {
          //在微信中打开
          gotoOAuth()
          return
        }else{
          alert('请使用微信访问此网站')
          return
        }
      }
      if (!this.ifbingphone) { //未绑定手机号
        this.$router.push({
          name: 'bindphone'
        })
        return
      }
      if (this.selectedNum == 0) return
      const params = [{
        num: this.selectedNum,
        productId: this.selectedStandard.id,
      }];
      await api.saveCart(params);
      if(!this.iffromCart) {
        Toast.success('添加成功');
      }
      this.$emit('addCartSuccess');
      this.$emit('update:ifshow', false);
      //
    },
    //立即购买
    buyNow() {
      //未登录注册
      if (!getToken()) {
        //没有登陆过就跳转鉴权页
        let ua = navigator.userAgent.toLowerCase();//获取判断用的对象
        if (ua.match(/MicroMessenger/i) === "micromessenger" || (Array.isArray(ua.match(/MicroMessenger/i)) && ua.match(/MicroMessenger/i)[0] === "micromessenger")) {
          //在微信中打开
          gotoOAuth()
          return
        }else{
          alert('请使用微信访问此网站')
          return
        }
      }
      if (!this.ifbingphone) { //未绑定手机号
        this.$router.push({
          name: 'bindphone'
        })
        return
      }
      if (this.selectedNum == 0) return
      //生成订单页需要的数据
      const { supplierId, supplierName, goodsName } = this.goodsDetail;
      let params = {
        supplierId,
        supplierName,
        goods: [
          {
            ...this.selectedStandard,
            selectedNum: this.selectedNum,
            goodsName,
          },
        ],
      };
      this.distributionUser && (params.distributionUser = this.distributionUser);
      //设置订单类型为单个商品
      localStorage.setItem('settleType', 1);
      this.$router.push({
        path: '/generate-settle',
        query: { standard: JSON.stringify(params) },
      });
    },
    //确定
    confirm() {
      //未登录注册
      if (!getToken()) {
        //没有登陆过就跳转鉴权页
        let ua = navigator.userAgent.toLowerCase();//获取判断用的对象
        if (ua.match(/MicroMessenger/i) === "micromessenger" || (Array.isArray(ua.match(/MicroMessenger/i)) && ua.match(/MicroMessenger/i)[0] === "micromessenger")) {
          //在微信中打开
          gotoOAuth()
          return
        }else{
          alert('请使用微信访问此网站')
          return
        }
      }
      if (!this.ifbingphone) { //未绑定手机号
        this.$router.push({
          name: 'bindphone'
        })
        return
      }
      if (this.selectedNum == 0) return
      if (this.btnType === 1) {
        this.addToCart();
      } else {
        this.buyNow();
      }
    },
    closeStandard() {
      if (this.ifshow) {
        this.$emit('update:ifshow', false);
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import 'common/sass/theme.scss';
.select-standard-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  z-index: -1;
  .background-mask {
    width: 100vw;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 110;
  }
  .select-standard-body {
    position: fixed;
    bottom: -68vh;
    width: 100%;
    height: 68vh;
    background: #fff;
    opacity: 0;
    z-index: 111;
    transition: bottom 0.3s;
    //头部，商品图片，价格
    .standard-heaader {
      height: 80px;
      .close-btn {
        position: absolute;
        top: 10px;
        right: 10px;
      }
      .goods-header {
        height: 100%;
        .standard-img {
          position: absolute;
          top: -20px;
          left: 10px;
          width: 90px;
          height: 90px;
          background: #fff;
          border-radius: 2px;
          overflow: hidden;
          img {
            display: inline-block;
            width: 100%;
            height: 100%;
          }
        }
        .price-box {
          display: inline-block;
          margin: 10px 0 0 110px;
          font-size: 12px;
          .has-select {
            color: $light-color;
          }
          .selected-standard-name {
            margin-left: 5px;
          }
        }
      }
    }
    .standard-content {
      width: 100%;
      flex: 1;
      overflow: auto;
      /*选择规格*/
      .all-standard-list {
        padding: 0 10px;
        .standard-item-box {
          margin-bottom: 20px;
          .standard-name {
            color: $light-color;
            font-size: 12px;
          }
          .standard-item {
          }
          .selected-item {
            background: $theme-color;
            color: #fff !important;
            border: none;
          }
        }
      }
      /*选择数量*/
      .select-num {
        padding: 0 10px;
        margin-bottom: 20px;
        .select-num-name {
          color: $light-color;
          font-size: 12px;
        }
      }
    }
    //加入购物车，购买商品按钮
    .bottom-btn-box {
      display: flex;
      width: 100vw;
      height: 50px;
      line-height: 50px;
      text-align: center;
      color: #fff;
      .add-shopping-cart {
        flex: 1;
        background: #f90;
      }
      .buy-btn {
        flex: 1;
        background: $theme-color;
      }
      .confirm-btn {
        flex: 1;
        background: $theme-color;
      }
      .no-stock{
        background: #b4b4b4;
      }
    }
  }
  .selected-active {
    display: flex;
    flex-direction: column;
    bottom: 0;
    opacity: 1;
  }
  .standard-loading{
    position: absolute;
    top: 40%;
    left: 50%;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: bottom 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  bottom: -68vh;
}
</style>
